// export default Subscribe;

import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import getUrlParamValue from 'src/utils/getUrlParamValue';
import { Box, Alert, Typography, Link } from '@mui/material';
import { useMutation } from '@apollo/client';
import { LoadingButton } from '@mui/lab';
import { MotionContainer, varBounceIn } from './animate';
import { SUBSCRIBE_USER, FRAUD_CHECK } from '../graphql';

const Subscribe = ({ code }) => {
  const navigate = useNavigate();

  const [subscribeUser, { loading, error }] = useMutation(SUBSCRIBE_USER);
  const [fraudCheck] = useMutation(FRAUD_CHECK);

  const handleSubscription = async () => {
    try {
      const { data } = await subscribeUser();

      if (data.subscribeUser.responseCode === 202) {
        const msisdn = data.subscribeUser.msisdn;
        const click_id = sessionStorage.getItem('click_id');
        const advertiser_id = sessionStorage.getItem('advertiser_id');

        const user_agent = navigator.userAgent;
        const source_ip = await fetch("https://api.ipify.org?format=json")
          .then(res => res.json())
          .then(data => data.ip);

        localStorage.setItem('msisdn', msisdn);
        navigate('/processing');

        const fraudResponse = await fraudCheck({
          variables: { msisdn, click_id,user_agent,source_ip,advertiser_id },
        });

        const cg_url = fraudResponse?.data?.fraudCheck?.cg_url;
        console.log(fraudResponse?.data)

        if (cg_url) {
          window.open(cg_url, '_self');
        } else {
          console.error('CGI URL not found in response');
        }
      }
    } catch (err) {
      console.error('Subscription error:', err.message);
    }
  };

  const disagree = () => {
    localStorage.setItem('newUser', 'newUser');
    navigate('/');
  };

  let param = getUrlParamValue('m');
  param = param
    ? 'Please credit account to continue enjoying service.'
    : 'There is always something fun to play.';

  return (
    <MotionContainer initial="initial" open>
      <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
        <motion.div variants={varBounceIn}>
          <Box component="img" src="/static/newlogo.png" sx={{ height: 200, mx: 'auto' }} />
        </motion.div>
        <motion.div variants={varBounceIn}>
          <Typography variant="h4" paragraph>
            Hundreds of games to play.
          </Typography>
        </motion.div>
        <Typography sx={{ color: 'text.secondary', mb: 3 }}>{param}</Typography>

        <Typography sx={{ color: 'text.secondary', mb: 3 }}>
          {[304, 404, 504].includes(code) && (
            <>You don't have an active subscription. Please subscribe to continue.</>
          )}
          {error && <Alert severity="error">{error.message}</Alert>}
        </Typography>

        <LoadingButton
          onClick={handleSubscription}
          sx={{ width: '280px', mb: 3 }}
          size="large"
          variant="contained"
          loading={loading}
        >
          Subscribe
        </LoadingButton>

        <LoadingButton
          onClick={disagree}
          color="error"
          sx={{ width: '280px' }}
          size="large"
          variant="outlined"
        >
          Cancel
        </LoadingButton>

        <Typography sx={{ color: 'text.secondary', my: 3 }}>
          Cost kshs. 15 per day
        </Typography>
        <Typography variant="subtitle2" sx={{ mt: 1, textAlign: 'center' }}>
          <Link to="/terms-conditions" component={RouterLink}>
            T&amp;Cs
          </Link>
        </Typography>
      </Box>
    </MotionContainer>
  );
};

Subscribe.propTypes = {
  code: PropTypes.number,
};

export default Subscribe;
